<template>
  <div ref="chartRef" class="line-chart"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ElectricityChart',
  props: {
    data: { type: Array, default: () => [] }
  },
  data() {
    return {
      chartInst: null,
      ro: null
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chartInst && this.render()
      }
    }
  },
  mounted() {
    this.tryInit()
  },
  beforeDestroy() {
    this.clean()
  },
  methods: {
    /* 🔧 修复关键：第一次挂载时若高度为 0（v-show=false）则等待出现高度再渲染 */
    tryInit() {
      const dom = this.$refs.chartRef
      if (!dom) return
      if (dom.clientHeight > 0) {
        this.render()
        return
      }
      this.ro = new ResizeObserver(entries => {
        const h = entries[0].contentRect.height
        if (h > 0) {
          this.ro.disconnect()
          this.ro = null
          this.render()
        }
      })
      this.ro.observe(dom)
    },

    /* 真正初始化 / 更新图表 */
    render() {
      this.$nextTick(() => {
        const dom = this.$refs.chartRef
        if (!dom || dom.clientHeight === 0) return
        if (!this.chartInst) {
          this.chartInst = echarts.init(dom)
          window.addEventListener('resize', this.handleResize)
        }
        this.chartInst.setOption(this.buildOption(), true)
        this.chartInst.resize()
      })
    },

    handleResize() {
      this.chartInst && this.chartInst.resize()
    },

    /* 折线图 option */
    buildOption() {
      const xData = this.data.map(i => i.dataTime)
      const yData = this.data.map(i => i.energy)
      const yData2 = this.data.map(i => i.lastPeriodEnergy)
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 50, right: 16, top: 16, bottom: 20 },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E4E7ED' } },
          axisTick: { show: false },
          axisLabel: { color: '#7D879F', fontSize: 12 }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          splitLine: { lineStyle: { color: '#f0f0f0' } },
          axisLabel: { color: '#7D879F', fontSize: 12 }
        },
        series: [
          {
            name: '能耗',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            itemStyle: { color: '#2A62FF' },
            lineStyle: { color: '#2A62FF', width: 2 },
            areaStyle: { color: 'rgba(42,98,255,0.08)' },
            data: yData
          },
          {
            name: '同期能耗',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            itemStyle: { color: '#91B3FF' },
            lineStyle: { color: '#91B3FF' },
            areaStyle: { color: 'rgba(145,179,255,0.08)' },
            data: yData2
          }
        ]
      }
    },

    clean() {
      if (this.ro) { this.ro.disconnect(); this.ro = null }
      if (this.chartInst) { this.chartInst.dispose(); this.chartInst = null }
      window.removeEventListener('resize', this.handleResize)
    }
  }
}
</script>

<style scoped>
.line-chart {
  width: 100%;
  height: 100%;
  min-height: 0;
}
</style>
